import { FaArrowLeft } from "react-icons/fa6";

// components
import Button from "@/shared/Button";

// helpers
import queryString from "@/helpers/queryString";
import useStorage from "@/hooks/useStorage";

// assets
import styles from "@/assets/styles/components/back-to-search-results.module.scss";

function BackToSearchResults({ defaultQuery = "" }: { defaultQuery: string }) {
  const [lastSearchQuery] = useStorage("session", "lastSearchQuery");
  
  const searchParams = queryString.stringify(JSON.parse(lastSearchQuery || "{}"))

  const query = searchParams ? searchParams : defaultQuery;

  return (
    <Button
      to={`/search-results${query && `?${query}`}`}
      type="tertiary"
      icon={<FaArrowLeft/>}
      linkClassName={styles["locl-back-to-search-results__link"]}
      data-testid="locl-back-to-search-results"
    >
      Back to search results
    </Button>
  );
}

export default BackToSearchResults;
